import { useEffect, useState } from "react";
import { Button } from "antd";
import Main from "../../components/layout/Main";
import ClockImage from "../../assets/images/clock-image.svg";
import PlayerProfile from "../../assets/images/for-prodile-player.jpg";
import { useNavigate } from "react-router";
import { useSocket } from "./useSocket";
import { getChannelName } from "../../helper/functions";
import { useGlobalSearch } from "../../context/GlobalSearchContext";
import HLSPlayer from "../../components/HLSPlayer";
const podcastCategories = [
  "All",
  // "Tournaments",
  // "News",
  // "Technology",
  // "Games",
  // "Minecraft",
];

const LivestreamIndex = () => {
  const { globalSearch } = useGlobalSearch();
  const [livestreams, setLivestreams] = useState([]);

  const [activeCategory, setActiveCategory] = useState("All");
  const navigate = useNavigate();
  const filteredStreams =
    activeCategory === "All"
      ? livestreams
      : livestreams.filter((stream) => stream.category === activeCategory);
  // ------------- connect to sockets ---------------
  const socket = useSocket(globalSearch);

  // ----------- Functions & Handlers ---------------
  const safeChannelFrom = (link) => {
    if (!link || typeof link !== "string") return null;

    try {
      return getChannelName(link);
    } catch (err) {
      console.error("getChannelName failed:", link, err);
      return null;
    }
  };

  // ----------- Use Effects ----------
  useEffect(() => {
    if (Array.isArray(socket)) {
      setLivestreams(socket);
    } else {
      console.warn("Unexpected socket data:", socket);
    }
  }, [socket, globalSearch]);

  return (
    <Main>
      <div className="section-main">
        <div className="podcast-page">
          <div className="orange-header">Live Streams</div>

          {/* Filter Buttons */}
          <div className="game-modes-filter" style={{ marginBottom: 20 }}>
            {podcastCategories.map((mode) => (
              <Button
                key={mode}
                type={activeCategory === mode ? "primary" : "default"}
                onClick={() => setActiveCategory(mode)}
                className="mode-filter-btn"
                style={{ marginRight: 8 }}
              >
                {mode}
              </Button>
            ))}
          </div>

          {/* Video Grid */}
          <div>
            <div className="for-auction-main">
              {filteredStreams && filteredStreams.length > 0 ? (
                filteredStreams.map((item, index) => {
                  // check link is which plateform kick or twitch
                  const isTwitch =
                    typeof item?.streamLink === "string" &&
                    item.streamLink.includes("twitch.tv");

                  const isKick =
                    typeof item?.streamLink === "string" &&
                    item.streamLink.includes("kick.com");
                  const channel = safeChannelFrom(item?.streamLink);
                  return (
                    <div
                      key={index}
                      className="for-live-video-grid-inner"
                      onClick={() =>
                        navigate(`/live-stream/send-gift/${item?.id}`)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {/* Video Thumbnail */}
                      <div className="for-live-video-grid-inner-image for-live-video-grid-inner-image-livve">
                        {isTwitch ? (
                          <iframe
                            src={`https://player.twitch.tv/?channel=${channel}&parent=${window.location.hostname}&autoplay=false&muted=true`}
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            allow="autoplay"
                            allowFullScreen
                          />
                        ) : isKick ? (
                          <iframe
                            src={`https://player.kick.com/${channel}?autoplay=false&muted=true`}
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            allow="autoplay"
                            allowFullScreen
                          />
                        ) : (
                          <video
                            src={item?.currentStreamLink}
                            autoPlay
                            muted
                            controls
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          // <HLSPlayer url={item.currentStreamLink} />
                        )}

                        {/* <span className="live-tag">{item?.status}</span> */}
                        <h5>
                          <img src={ClockImage} alt="clock" /> {item?.viewers}
                        </h5>
                      </div>
                      {/* Info Footer */}
                      <div className="for-live-video-grid-footer">
                        <div className="player-profile">
                          <img src={PlayerProfile} alt={item?.player} />
                        </div>
                        <div className="for-player-text">
                          <h5>{item?.name}</h5>
                          <p>{item?.game?.name}</p>
                          <div className="for-player-tags">
                            {item?.tags?.map((tag, i) => (
                              <span key={i}>{tag}</span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p>Live streams not available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </Main>
  );
};

export default LivestreamIndex;
